"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    formaterNummer: function() {
        return formaterNummer;
    },
    ingen: function() {
        return ingen;
    },
    tall: function() {
        return tall;
    },
    stortTall: function() {
        return stortTall;
    },
    desimaltall: function() {
        return desimaltall;
    },
    desimaltallVisAlt: function() {
        return desimaltallVisAlt;
    },
    positivtTall: function() {
        return positivtTall;
    },
    organisasjonsnummer: function() {
        return organisasjonsnummer;
    },
    boolsk: function() {
        return boolsk;
    },
    prosent: function() {
        return prosent;
    },
    dato: function() {
        return dato;
    },
    ledendeTegn: function() {
        return ledendeTegn;
    }
});
var _isBoolean = /*#__PURE__*/ _interop_require_default(require("lodash/isBoolean"));
var _dayjs = /*#__PURE__*/ _interop_require_default(require("dayjs"));
var _sjekker = require("../../felt/sjekker");
var _padStart = /*#__PURE__*/ _interop_require_default(require("lodash/padStart"));
var _utils = require("../../validering/utils");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var formaterStortTall = function(verdi, locale) {
    var overrideLocale = locale !== "en" ? "nb" : locale;
    var options = {
        style: "decimal",
        useGrouping: true,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    };
    var stringVerdi = "" + verdi;
    if ((0, _utils.erHeltall)(stringVerdi)) {
        var number = BigInt(stringVerdi);
        return number.toLocaleString(overrideLocale, options);
    } else {
        var heltallDel = (0, _utils.getHeltallsDel)(stringVerdi);
        var desimaltallDel = (0, _utils.getDesimaltallsDel)(stringVerdi);
        if ((0, _utils.erHeltall)(heltallDel) && desimaltallDel !== undefined && (0, _utils.erHeltall)(desimaltallDel)) {
            var separator = locale !== "en" ? "," : ".";
            return BigInt(heltallDel).toLocaleString(overrideLocale, options) + separator + desimaltallDel;
        } else if ((0, _utils.erHeltall)(heltallDel)) {
            return BigInt(heltallDel).toLocaleString(overrideLocale, options);
        } else {
            return verdi;
        }
    }
};
var formaterNummer = function(verdi, locale, param) {
    var minimumFractionDigits = param.minimumFractionDigits, maximumFractionDigits = param.maximumFractionDigits;
    var number = Number(verdi);
    if (isNaN(number)) {
        return verdi;
    }
    var overrideLocale = locale !== "en" ? "nb" : locale;
    return number.toLocaleString(overrideLocale, {
        style: "decimal",
        useGrouping: true,
        maximumFractionDigits: maximumFractionDigits,
        minimumFractionDigits: minimumFractionDigits
    });
};
var ingen = {
    navn: "Ingen transformering",
    description: "Returnerer verdi uten transformering. Kan f.eks. brukes p\xe5 opsjoner som ikke trenger kodeliste",
    transform: function(felt, verdi) {
        return verdi;
    }
};
function harIkkeVerdi(verdi) {
    return verdi === undefined || verdi === "" || verdi === _sjekker.SLETTET_VERDI;
}
var tall = {
    navn: "Tall",
    description: "Mapper input til tall format med norsk locale",
    transform: function(felt, verdi) {
        var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_antallDesimaler = _ref.antallDesimaler, antallDesimaler = _ref_antallDesimaler === void 0 ? 0 : _ref_antallDesimaler, _ref_intl = _ref.intl, intl = _ref_intl === void 0 ? {} : _ref_intl;
        if (harIkkeVerdi(verdi)) {
            return "";
        }
        var locale = intl.locale;
        return formaterNummer(verdi, locale, {
            minimumFractionDigits: antallDesimaler,
            maximumFractionDigits: antallDesimaler
        });
    }
};
var stortTall = {
    navn: "Stort tall",
    description: "Mapper input til tall format for store tall",
    transform: function(felt, verdi) {
        var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_intl = _ref.intl, intl = _ref_intl === void 0 ? {} : _ref_intl;
        if (harIkkeVerdi(verdi)) {
            return "";
        }
        var locale = intl.locale;
        return formaterStortTall(verdi, locale);
    }
};
var desimaltall = {
    navn: "Desimaltall",
    description: "Mapper input til desimaltall format med norsk locale",
    transform: function(felt, verdi) {
        var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_intl = _ref.intl, intl = _ref_intl === void 0 ? {} : _ref_intl;
        if (verdi === undefined || verdi === "") {
            return "";
        }
        var locale = intl.locale;
        var verdiStreng = verdi.replace(",", ".");
        return formaterNummer(verdiStreng, locale, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }
};
var desimaltallVisAlt = {
    navn: "Desimaltall - vis alle desimaler",
    description: "Mapper input til desimaltall format med norsk locale",
    transform: function(felt, verdi) {
        var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_intl = _ref.intl, intl = _ref_intl === void 0 ? {} : _ref_intl;
        if (verdi === undefined || verdi === "") {
            return "";
        }
        var locale = intl.locale;
        var verdiStreng = verdi.replace(",", ".");
        var antallDesimaler = verdiStreng.indexOf(".") > 0 ? verdiStreng.split(".")[1].length : 0;
        return formaterNummer(verdiStreng, locale, {
            maximumFractionDigits: antallDesimaler
        });
    }
};
var positivtTall = {
    navn: "Positivt tall",
    description: "Mapper input til tall format med norsk locale - fjerner eventuelt negativt fortegn",
    transform: function(felt, verdi) {
        var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_antallDesimaler = _ref.antallDesimaler, antallDesimaler = _ref_antallDesimaler === void 0 ? 0 : _ref_antallDesimaler, _ref_intl = _ref.intl, intl = _ref_intl === void 0 ? {} : _ref_intl;
        var transformertVerdi = tall.transform(felt, verdi, {
            antallDesimaler: antallDesimaler,
            intl: intl
        });
        if ((0, _utils.isIkkePositivtHeltall)((0, _utils.getHeltallsDel)(verdi))) {
            return transformertVerdi.slice(1);
        }
        return transformertVerdi;
    }
};
var organisasjonsnummer = {
    navn: "Organisasjonsnummer",
    description: "Mapper referansene til orgnr: 1234",
    transform: function(felt, verdi) {
        return "Orgnr. ".concat(verdi);
    }
};
var boolsk = {
    navn: "Boolsk",
    description: "Mapper boolsk verdi til Ja eller Nei",
    transform: function(felt, verdi, options) {
        if (verdi === undefined || verdi === "") {
            return verdi;
        }
        if (options) {
            var id = verdi + "" === "true" ? "kodeliste.boolsk.ja" : "kodeliste.boolsk.nei";
            if (options.returnerId) {
                return id;
            }
            if (options.intl) {
                return options.intl.formatMessage({
                    id: id,
                    defaultMessage: verdi
                });
            }
        }
        if (!(0, _isBoolean.default)(verdi) && verdi !== 0 && verdi !== 1) {
            return verdi;
        }
        return verdi ? "Ja" : "Nei";
    }
};
var prosent = {
    navn: "Prosent",
    description: "Forventer et objekt med teller og nevner inn og returnerer %",
    transform: function(felt, data) {
        if (data === undefined) {
            return undefined;
        }
        if (data.teller !== undefined) {
            var verdi = (data.teller / data.nevner * 100).toFixed(2);
            var retVal = verdi.indexOf(".00") === -1 ? verdi : verdi.substring(0, verdi.length - 3);
            return retVal.replace(".", ",");
        }
        return data;
    }
};
var dato = {
    navn: "Dato",
    description: "Formatterer dato til norsk datoformat",
    transform: function(felt, date) {
        return (0, _dayjs.default)(date).format("DD.MM.YYYY");
    }
};
var ledendeTegn = {
    navn: "Ledende tegn",
    description: "Legger p\xe5 ledende tegn",
    transform: function(felt, verdi) {
        var _felt_transformer_args, _felt_transformer_args1;
        if (verdi === null || verdi === undefined || !((_felt_transformer_args = felt.transformer.args) === null || _felt_transformer_args === void 0 ? void 0 : _felt_transformer_args.antall) || !((_felt_transformer_args1 = felt.transformer.args) === null || _felt_transformer_args1 === void 0 ? void 0 : _felt_transformer_args1.tegn)) {
            return verdi;
        }
        return (0, _padStart.default)(verdi, felt.transformer.args.antall, felt.transformer.args.tegn);
    }
};
